<template>
  <div class="device-list-page" style="height: 100%; overflow: auto;">
    <!-- 顶部导航栏 -->
    <div slot="header" class="card-header">
      <i class="el-icon-s-claim" style="color: #caff00" ></i>
      <span style="color:#fff;margin-left: 5px">设备列表</span>
    </div>
    <el-divider content-position="center">提交表单</el-divider>
    <!-- 搜索区域 -->
    <div class="search-box">
      <el-form :model="validateForm" ref="validateForm" label-position="left" label-width="75px" class="demo-ruleForm" size="small">
        <el-row>
          <el-col :span="24">
            <el-form-item label="设备名称" prop="tel">
              <el-input v-model.number="validateForm.meterName" placeholder="设备名称关键字" clearable autocomplete="off" ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="16">
            <el-form-item label="设备编号" prop="tel">
              <el-input v-model.number="validateForm.deviceCode" placeholder="设备代码后六位" clearable autocomplete="off" ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8" style="display: flex;justify-content: center">
            <el-form-item>
              <el-button type="primary" @click="searchDevices">搜索</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- 设备状态筛选 -->
    <div class="filter-options">
      <el-radio-group v-model="filterStatus" >
        <el-radio v-for="count in countList" :label="count.value" @change="activeTabClick(count.value)">{{count.name}}: {{count.num}}台</el-radio>
      </el-radio-group>
    </div>
    <el-divider content-position="center">设备列表</el-divider>
    <!-- 设备列表 -->
    <div class="device-list">
      <div v-for="device in devicesForm" :key="device.id" class="device-item" @click="handleDetail(device)">
        <el-row class="topRow">
          <el-row>
            <el-col :span="24">
              <span class="device-name">{{ device.meterName }}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="18">
              <span class="label">设备编号 :</span>
              <span class="value">{{ device.deviceCode }}</span>
            </el-col>
            <el-col :span="6" style="display: flex;justify-content: right">
              <span>
                <el-tag type="success" v-if="device.netState=='1'" size="small" effect="dark"><i class="el-icon-circle-check" style="padding-right: 3px"></i>在线</el-tag>
                <el-tag type="danger" v-if="device.netState=='0'" size="small" effect="dark"><i class="el-icon-circle-close" style="padding-right: 3px"></i>离线</el-tag>
              </span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="18">
              <span class="label">最新上报 :</span>
              <span class="value" v-if="device.netWorkTime==null" style="color: red">未上线</span>
              <span class="value" v-else>{{device.netWorkTime }}</span>
            </el-col>
            <el-col :span="6" style="display: flex;justify-content: right" class="chat-square">
              <span class="label">信号值 :</span>
              <span class="value" v-if="device.netWorkTime==null || device.netState=='0'" style="color: red">0</span>
              <span class="value" v-else-if="device.netState=='1' && device.rsrp=='Y'" style="color: green">{{device.csq}}</span>
              <span class="value" v-else style="color: green">{{26}}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10">
              <span class="label">瞬时流量 :</span>
              <span class="value">{{ device.instantFlow==null?0:device.instantFlow }}</span>
              <span>m³/h</span>
            </el-col>
            <el-col :span="14" style="display: flex;justify-content: right">
              <span class="label">正向累积流量 :</span>
              <span class="value" >{{device.positiveCumulativeFlow==null?0:device.positiveCumulativeFlow }}</span>
              <span style="align-content:flex-end;">m³</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="14" style="display: flex;justify-content: left">
              <span class="label">反向累积流量 :</span>
              <span class="value" >{{device.reverseCumulativeFlow==null?0:device.reverseCumulativeFlow }}</span>
              <span style="align-content:flex-end;">m³</span>
            </el-col>
          </el-row>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'deviceList',
  data() {
    return {
      validateForm:{
        tel: '',
        deviceCode: '',
        meterName: '',
        netState: ''
      },
      countList:[{
        name: '全部',
        value: 'all',
        num:0
      },{
        name: '在线',
        value: 'online',
        num:0
      },{
        name: '离线',
        value: 'offline',
        num:0
      }],
      devicesForm:[],
      searchKeyword: '',
      searchCode: '',
      filterStatus: 'all',
    };
  },
  created() {
    // 接收路由参数（两种方式）
    // 方式1：接收路由传参（推荐）
    this.validateForm = {tel: this.$route.query.tel};
    this.getQueryList("created");
  },
  methods: {
    activeTabClick(sign){
      this.loading = true;
      if(sign=="all"){
        this.validateForm.netState = "";
      }else if (sign=="online"){
        this.validateForm.netState = "1";
      }else if (sign=="offline"){
        this.validateForm.netState = "0";
      }
      this.getQueryList("1");
    },
    //跳转详情页面
    handleDetail(row){
      this.$router.push({
        path: '/scan',
        query: {deviceCode: row.deviceCode}
      });
    },
    getQueryList(sign) {
      this.$http.post(process.env.VUE_APP_API_BASE_URL+'deviceInfo/device_info/scan_query_list', this.validateForm)
        .then(res => {
          if (res.code === 200 && res.hasOwnProperty("data")) {
            if(sign!="1" || this.filterStatus == "all"){
              this.searchByCode(res.data);
            }
           this.devicesForm = res.data;
           if(sign != "created"){
             this.$message({
               message: '恭喜哦，数据加载成功. . . . . .',
               type: 'success',
               center: true,
               offset:50
             });
           }
          } else {
            this.$message({
              message: '抱歉哦，数据加载失败. . . . . .',
              type: 'warning',
              center: true,
              offset:50
            });
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    searchByCode(list){
      // 统计在线和离线设备数量
      const onlineCount = list.filter(device => device.netState === '1').length;
      const offlineCount = list.filter(device => device.netState === '0').length;
      // 更新 countList 数组
      this.countList = [
        { name: '全部', value: 'all', num: list.length },
        { name: '在线', value: 'online', num: onlineCount },
        { name: '离线', value: 'offline', num: offlineCount }
      ];
    },
    searchDevices(){
      this.filterStatus = "all";
      this.activeTabClick(this.filterStatus);
      this.loading = true;
      this.getQueryList(2);
      console.log(this.validateForm);
    }
  }
};
</script>

<style scoped>
.chat-square .span{
  font-size: 25px;
  font-weight: bold;
}
.card-header {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 600;
  position: relative;
  height: 55px;
  background: #409eff;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
.card-header span {
  margin-left: 3px;
  font-size: 15px;
}
.topRow .el-row:nth-child(1){
  border-bottom: solid 1px #f3ebeb;
  padding-bottom: 5px;
}
.topRow .el-row:nth-child(even){
  padding: 5px 0;
}

.device-list-page {
  font-family: Arial, sans-serif;
  background-color: #f5f5f5;
}
::v-deep .el-divider__text{
  background: #f5f5f5;
}

.search-box {
  padding: 0 8px 8px 8px;
}

.filter-options {
  margin: 2px 0;
  display: flex;
  justify-content: center;
}

.device-list {
  padding: 0 8px 8px 8px;
  height: 700px;
  overflow: auto;
}
.device-list .device-item:nth-last-child(1) {
  margin-bottom: 260px;
}

.device-item {
  background-color: white;
  border-radius: 8px;
  padding: 9px;
  margin-bottom: 15px;
  box-shadow: 0 2px 5px rgba(0,0,0,0.1);
}

.demo-ruleForm .el-row{
  padding: 0 8px;
}
.demo-ruleForm .el-row .el-form-item{
  margin-bottom: 8px;
}

::v-deep .demo-ruleForm .el-col-8 .el-form-item .el-form-item__content{
  margin-left: 0!important;
}


.device-name {
  font-weight: bold;
  font-size: 16px;
}

.label {
  color: #666;
  font-size: 15px;
}

.value {
  color: #333;
  align-content:flex-end;
  margin: 0 3px;
  font-weight: bold;
  font-size: 15px;
}

</style>
